<div class="menu-sigalett">
	<p-menubar [model]="items">
		<ng-template pTemplate="start">
			<a class="navbar-brand" routerLink="/" routerLinkActive="active">{{ 'MENU.TITRE_APPLICATION' | translate }}</a>
		</ng-template>
		<ng-template pTemplate="item" let-item>
			<ng-container>
				@if (verifierDroits(item.droit)) {
					<a [routerLink]="item.route"
					   class="p-menuitem-link"
					   [ngClass]="{'active': isActive(item)}">
						<span [class]="item.icon"></span>
						<span class="ml-2">{{ item.label }}</span>
					</a>
				}
			</ng-container>
		</ng-template>
		<ng-template pTemplate="end">
			<p-toast/>
			<p-menu #menu [model]="utilisateurItems" [popup]="true"/>
			<p-button
					(onClick)="menu.toggle($event)"
					icon="pi pi-user"
					styleClass="button-utilisateur p-button-rounded"/>
		</ng-template>
	</p-menubar>
</div>
